import React from "react";
// react plugin for creating charts
// react plugin for creating vector maps

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Typography, SvgIcon } from "@material-ui/core";

// @material-ui/icons
// import ContentCopy from "@material-ui/icons/ContentCopy";
// import InfoOutline from "@material-ui/icons/InfoOutline";

// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import CardFooter from "components/Card/CardFooter";

import { ReactComponent as Cog } from "assets/icons/cog.svg";
import { ReactComponent as Module } from "assets/icons/modicon.svg";

import styles from "assets/jss/elite-feats-cms/views/dashboardStyle";
import axios from "axios";
import ModTools from "./ModTools";
import ClipLoader from "react-spinners/FadeLoader";
import { css } from "@emotion/react";
/* import priceImage1 from "assets/img/card-2.jpeg";
import priceImage2 from "assets/img/card-3.jpeg";
import priceImage3 from "assets/img/card-1.jpeg"; */

const us_flag = (require("assets/img/flags/US.png") as { default: string }).default;
const de_flag = (require("assets/img/flags/DE.png") as { default: string }).default;
const au_flag = (require("assets/img/flags/AU.png") as { default: string }).default;
const gb_flag = (require("assets/img/flags/GB.png") as { default: string }).default;
const ro_flag = (require("assets/img/flags/RO.png") as { default: string }).default;
const br_flag = (require("assets/img/flags/BR.png") as { default: string }).default;

var mapData = {
  AU: 760,
  BR: 550,
  CA: 120,
  DE: 1300,
  FR: 540,
  GB: 690,
  GE: 200,
  IN: 200,
  RO: 600,
  RU: 300,
  US: 2920,
};

const useStyles = makeStyles(styles);

export default function Dashboard(): React.ReactElement {
  const [salesInfo, setSalesInfo] = React.useState<Record<string, unknown>>({});

  const [openUser, setOpenUser] = React.useState(false);
  const [totalModules, setTotalModules] = React.useState(0);
  const [totalTools, setTotalTools] = React.useState(0);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    axios
      .get<Record<string, { total: number }>>("/api/user/sales-info", {
        headers: {
          "auth-token": localStorage.getItem("token"),
        },
      })
      .then((res) => {
        setLoading(false);
        setSalesInfo(res.data);
        let modTot = 0;
        let toolTot = 0;
        for (let assessment in res.data) {
          if (assessment[0] === "m") {
            modTot += res.data[assessment]!.total;
          } else if (assessment[0] === "t") {
            toolTot += res.data[assessment]!.total;
          }
        }
        setTotalModules(modTot);
        setTotalTools(toolTot);
      });
  }, []);
  const openUserDetails = (user?: unknown) => {
    /*  setCurrentUser(user); */
    setOpenUser(true);
  };
  const ModuleIcon = () => (
    <SvgIcon style={{ fontSize: 36 }} component={Module} />
  );
  const ToolIcon = () => <SvgIcon style={{ fontSize: 36 }} component={Cog} />;
  const classes = useStyles();
  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

  return (
    <div>
      <GridContainer style={{ justifyContent: "center" }}>
        <GridItem xs={12} sm={6} md lg>
          <Card>
            <CardHeader
              color="modules"
              stats
              icon
              style={{
                display: "flex",
                justifyContent: "center",
                marginRight: 0,
              }}
            >
              <CardIcon color="modules">
                <ModuleIcon />
              </CardIcon>
            </CardHeader>

            <Typography className={classes.adminTitle} style={{ fontSize: 22 }}>
              Modules Sales
            </Typography>

            {loading ? (
              <React.Fragment>
                <ClipLoader
                  color={"#398bd6"}
                  loading={loading}
                  css={override}
                />{" "}
              </React.Fragment>
            ) : (
              <Typography
                className={classes.cardTitle}
                style={{ fontSize: 25, padding: 0, color: "#7c828b" }}
              >
                {totalModules}
              </Typography>
            )}

            <CardFooter style={{ marginTop: 10 }} stats></CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md lg>
          <Card>
            <CardHeader
              color="primary"
              stats
              icon
              style={{
                display: "flex",
                justifyContent: "center",
                marginRight: 0,
              }}
            >
              <CardIcon color="primary">
                <ToolIcon />
              </CardIcon>
            </CardHeader>

            <Typography className={classes.adminTitle} style={{ fontSize: 22 }}>
              Tools Sales
            </Typography>
            {loading ? (
              <React.Fragment>
                <ClipLoader
                  color={"#398bd6"}
                  loading={loading}
                  css={override}
                />{" "}
              </React.Fragment>
            ) : (
              <Typography
                className={classes.cardTitle}
                style={{ fontSize: 25, padding: 0, color: "#7c828b" }}
              >
                {totalTools}
              </Typography>
            )}
            <CardFooter style={{ marginTop: 10 }} stats></CardFooter>
          </Card>
        </GridItem>{" "}
      </GridContainer>
      <ModTools data={salesInfo} loading={loading} />
      {/*  <UserDetails user={currentUser} open={openUser} setOpen={setOpenUser} /> */}
    </div>
  );
}
